import React, { useEffect, useState } from "react"
import { AdClientType, AdItemType, AdItemTypeDefaultValue, AdItemTypeType, AdOrganizationType, AdProjectBundleType, AdProjectType, AdProjectTypeDefaultValue, AdStateType, AdStateTypesAsList } from "./AdTypes";
import { useSelector, useDispatch } from 'react-redux';
import { RdxStore } from "../../rdx/ReduxTypes";
import { CHANGE_AD_ADGROUPNAMES, CHANGE_AD_ADS, CHANGE_AD_CLIENTS, CHANGE_AD_ORGANIZATIONS, CHANGE_AD_PROJECTS } from "../../rdx/adReducer";
import { FetchHandler } from "../../Handlers/FetchHandler";
import { MessageBoxes } from "../../Handlers/MessageBoxes";
import { StringHelper } from "../../Handlers/Helpers";

const adTypes: AdItemTypeType[] = [
    "discovery_featured",
    "discovery_featured_secondary",
    "forum_feed",
    "calendar_list",
    "plantsearch",
    "plantdetail_main",
    "plantdetail_main_web",
    "monthly_article",

    "offer",
    // "discovery_featured_plants",
];
type AdAdminViewStates = "all" | "published";

type GroupedAdsType = {
    name: string,
    projectName: string,
    organizationdId: string,
    ids: string[],
    startDateKey: number,
    endDateKey: number
};

export const useAdAdmin = () => {

    const api = useAdApi();

    const adsStore: { [key: string]: AdItemType } = useSelector((state: RdxStore) => state.ads.ads);
    const adProjects: { [key: string]: AdProjectType } = useSelector((state: RdxStore) => state.ads.adProjects);
    const uiClients = useAdClients();

    const dispatch = useDispatch();
    const [showArchived, setShowArchived] = useState<boolean>(false);
    const [listofIds, setListofIds] = useState<string[]>([]);
    const [listofClientIds, setListofClientIds] = useState<string[]>([]);
    const [clientsfFilter, setClientsfFilter] = useState<string[]>([]);

    const [currentViewState, setCurrentViewState] = useState<AdStateType | "all">("all")
    const reload = async () => {
        await loadWithState(currentViewState);
        return;
        const cs: AdItemType[] = await api.getAds();
        let change = {};
        cs.forEach(c => change[c?.id] = c);
        dispatch({ type: CHANGE_AD_ADS, payload: change });


        const ap: AdProjectType[] = await api.getAdsProjects();
        let change_ap = {};
        ap.forEach(c => change_ap[c?.id] = c);
        dispatch({ type: CHANGE_AD_PROJECTS, payload: change_ap });

    }

    const loadWithState = async (state: AdStateType | "all") => {
        setCurrentViewState(state);
        const data = await api.getAdsWithState(state);

        const cs: AdItemType[] = data?.ads;
        let change = {};
        cs.forEach(c => change[c?.id] = c);
        dispatch({ type: CHANGE_AD_ADS, payload: change });

        const ap: AdProjectType[] = data?.adProjects;
        let change_ap = {};
        ap.forEach(c => change_ap[c?.id] = c);
        dispatch({ type: CHANGE_AD_PROJECTS, payload: change_ap });

    }

    useEffect(() => {
        if (adsStore) {
            const ids = Object.keys(adsStore).map(key => key);
            const c = Array.from(new Set(Object.keys(adsStore).map(key => { return !!adsStore?.[key]?.clientId ? adsStore?.[key]?.clientId : adsStore?.[key]?.organizationId })));
            setListofIds(ids);
            setListofClientIds(c);
        }
    }, [, adsStore]);

    // newAd
    const [newAdProjectModel, setNewAdProjectModel] = useState<AdProjectType>(AdProjectTypeDefaultValue);
    const [newAdModel, setNewAdModel] = useState<AdItemType>(AdItemTypeDefaultValue);
    const [newAdTypes, setNewAdTypes] = useState<AdItemTypeType[]>([]);
    const [newAdValid, setNewAdValid] = useState<boolean>(false);
    const newAdClear = async () => {
        setNewAdModel(AdItemTypeDefaultValue);
        setNewAdTypes([]);
        setNewAdValid(false);
    }

    // allAdsIds
    const [allAdsIds, setAllAdsIds] = useState<string[]>([]);
    const [allAdsIdWithoutProject, setAllAdsIdWithoutProject] = useState<string[]>([]);
    useEffect(() => {
        const _allAdsIds = Object.keys(adsStore ?? {}).map(key => adsStore?.[key]?.id);

        const _allAdsIdWithoutProject = Object.keys(adsStore ?? {}).filter(key => !adsStore?.[key]?.projectId).map(key => adsStore?.[key]?.id);

        setAllAdsIds(_allAdsIds);
        setAllAdsIdWithoutProject(_allAdsIdWithoutProject);
    }, [, adsStore]);

    // allAdsIds grouped
    const [allGrouped, setAllGrouped] = useState<GroupedAdsType[]>(undefined);
    useEffect(() => {
        let grps: GroupedAdsType[] = [];
        if (allAdsIds) {
            allAdsIds.forEach(id => {
                const organizationdId = !!adsStore?.[id]?.organizationId ? adsStore?.[id]?.organizationId : adsStore?.[id]?.clientId;
                const cid = !!adsStore?.[id]?.clientId ? adsStore?.[id]?.clientId : adsStore?.[id]?.organizationId;
                const client = uiClients.get(cid);

                const grp = !adsStore?.[id]?.adGroupName ? client?.name : client?.name + " - " + adsStore?.[id]?.adGroupName;

                if (grps.filter(m => m.name === grp)?.length <= 0) {
                    grps.push({
                        name: grp,
                        projectName: adsStore?.[id]?.adGroupName,
                        organizationdId: organizationdId,
                        ids: [],
                        startDateKey: 0,
                        endDateKey: 0
                    });
                }

                grps.filter(m => m.name === grp).forEach(g => g.ids.push(id));
            });
            grps.forEach(g => {
                g.ids.forEach(id => {
                    const startDateKey = adsStore?.[id]?.startDateKey;
                    const endDateKey = adsStore?.[id]?.endDateKey;
                    //Fix undefined
                    if (!!startDateKey && !g.startDateKey) {
                        g.startDateKey = startDateKey;
                    }
                    if (!!endDateKey && !g.endDateKey) {
                        g.endDateKey = endDateKey;
                    }

                    // fix more or less
                    if (!!startDateKey && startDateKey < g.startDateKey) {
                        g.startDateKey = startDateKey;
                    }
                    if (!!endDateKey && endDateKey > g.endDateKey) {
                        g.endDateKey = endDateKey;
                    }
                })
            })
            setAllGrouped(grps);
        }
    }, [allAdsIds])



    useEffect(() => {
        let valid = true;
        if (!(newAdModel?.name?.length > 2)) { valid = false; }
        if (!(newAdModel?.clientId?.length > 10) && !(newAdModel?.organizationId?.length > 10)) { valid = false; }
        if (!(newAdTypes?.length > 0)) { valid = false; }
        setNewAdValid(valid);
    }, [, newAdModel, newAdTypes])


    return {
        // ui 
        adTypes: adTypes,
        // load: load,
        loadWithState: loadWithState,
        get: (id: string): AdItemType => adsStore?.[id],
        all: allAdsIds,
        allAdsIdWithoutProject: allAdsIdWithoutProject,
        allGrouped: allGrouped,
        allClientIdsUsed: listofClientIds,

        clientSelected: (id: string) => { return clientsfFilter?.indexOf(id) >= 0; },
        clientsfFilterToggle: (id: string) => {
            if (clientsfFilter.indexOf(id) >= 0) {
                setClientsfFilter(clientsfFilter.filter(m => m != id));
            } else {
                setClientsfFilter([...clientsfFilter, id]);
            }
        },
        // add,
        newAdTypes: newAdTypes, setNewAdTypes: setNewAdTypes,
        newAdModel: newAdModel,
        newAdValid: newAdValid,
        newAdSave: async () => {
            const postObj = newAdTypes.map(type => {
                const p: AdItemType = { ...newAdModel, type: type, adstate: "draft" };
                return p;
            });
            const asas = await FetchHandler.postJson("/api/ads/addmulti", postObj);
            newAdClear();
            reload();
        },
        newAdClear: newAdClear,
        newAdChange: async (item: AdItemType) => {
            const n = { ...newAdModel, ...item };
            console.log("model:", n)
            setNewAdModel(n);
        },
        // Add project
        adProjects: adProjects,
        adProjectsAsList: Object.keys(adProjects ?? {}).map(key => adProjects?.[key]),
        newAdProjectModel: newAdProjectModel,
        setNewAdProjectModel: setNewAdProjectModel,
        newAdProjectChange: async (item: AdProjectType) => {
            const n = { ...newAdProjectModel, ...item };
            console.log("model:", n)
            setNewAdProjectModel(n);
        },
        newAdProjectValid: newAdProjectModel?.name?.length > 3 && (newAdProjectModel?.clientId?.length > 3 || newAdProjectModel?.organizationId?.length > 3),
        resetAdProjectSave: () => { setNewAdProjectModel(AdProjectTypeDefaultValue) },
        newAdProjectSave: async () => {
            const p: AdProjectType = { ...newAdProjectModel, adstate: "draft" };
            const asas = await FetchHandler.postJson("/api/ads/projects/add", p);
            reload();
        },
        adProjectUpdate: async (p: AdProjectType) => {
            const asas = await FetchHandler.patchJson("/api/ads/projects/update", p);
            reload();
        },
        onUpdateProjectType: async (projectId: string, state: AdStateType): Promise<boolean> => {
            const p = { adstate: state };
            var ret = await FetchHandler.patchJson("/api/ads/projects/" + projectId + "/statusupdate", p);
            reload();
            return ret;
        }
    }
}


// --------------------------------------------------------
// --------------------- useAdClients ---------------------
// --------------------------------------------------------
export const useAdClients = () => {
    const clients = useSelector((state: RdxStore) => state.ads.clients);
    const organizations = useSelector((state: RdxStore) => state.ads.organizations);
    const dispatch = useDispatch();
    const [listofIds, setListofIds] = useState<string[]>([]);

    const [newName, setNewName] = useState<string>("");

    useEffect(() => {
        if (!!clients && !!organizations) {
            const ids = Object.keys({ ...clients, ...organizations }).map(key => key);
            setListofIds(ids);
        }
    }, [, clients, organizations]);

    const load = async () => {
        const cs: AdClientType[] = await FetchHandler.getJson("/api/ads/clients");
        let change = {};
        cs.forEach(c => change[c?.id] = c);

        const os: AdOrganizationType[] = await FetchHandler.getJson("/api/organizations");
        let change_os = {};
        os.forEach(c => change_os[c?.id] = c);

        dispatch({ type: CHANGE_AD_ORGANIZATIONS, payload: change_os });
        dispatch({ type: CHANGE_AD_CLIENTS, payload: change });

    }

    return {
        load: load,
        get: (id: string): AdClientType | AdOrganizationType => {
            const c = clients?.[id];
            const o = organizations?.[id];
            return c ?? o;
        },
        newName: newName,
        newClientUpdateName: (name: string) => { setNewName(name); },
        addNewClient: async () => {
            if (newName?.length > 3) {
                const asas = await FetchHandler.postJson("/api/ads/clients/add", { name: newName })
                setNewName("");
                await load();
            } else {
                MessageBoxes.warning("Namnet måste ara minst 4 tecken")
            }
        },
        all: listofIds
    }
}

export const useAdItemEditor = (id: string, reloadList: () => void) => {
    const adsStore = useSelector((state: RdxStore) => state.ads.ads);
    const clients = useSelector((state: RdxStore) => state.ads.clients);
    const adGroupNames: { [key: string]: string[] } = useSelector((state: RdxStore) => state.ads.adGroupNames);
    const dispatch = useDispatch();

    const api = useAdApi();

    const item: AdItemType = adsStore?.[id];
    const [editItem, setEditItem] = useState<AdItemType>(item);
    const [editedFields, setEditedFields] = useState<AdItemType>({ id: id });
    const [changed, setChanged] = useState<boolean>(false);
    useEffect(() => {
        setEditItem(item)
        setChanged(false);
    }, [item])

    const client: AdClientType = clients?.[item?.clientId];

    const loadAll = async () => {
        await reloadList();
        return;

        const cs: AdItemType[] = await api.getAds();
        let change = {};
        let _adgroups = {};
        cs.forEach(c => {
            change[c?.id] = c;

            if (!_adgroups[c?.clientId ?? c?.organizationId]) {
                _adgroups[c?.clientId ?? c?.organizationId] = [];
            }
            if (!!c?.adGroupName && _adgroups[c?.clientId ?? c?.organizationId].indexOf(c.adGroupName) < 0) {
                _adgroups[c?.clientId ?? c?.organizationId].push(c?.adGroupName);
            }
        });
        dispatch({ type: CHANGE_AD_ADS, payload: change });
        dispatch({ type: CHANGE_AD_ADGROUPNAMES, payload: _adgroups });

    }

    return {
        adTypes: adTypes,
        adStates: AdStateTypesAsList,
        item: editItem,
        adGroupNames: adGroupNames,
        getItemPlantIds: (): string[] => {
            if (!editItem?.plantIds) {
                return [];
            }
            return (editItem?.plantIds).split(';')?.filter(m => StringHelper.isGuid(m));
        },
        allClients: Object.keys(clients ?? {}).map(key => clients?.[key]) as AdClientType[],
        clientName: client?.name,
        edit: (model: AdItemType) => {
            console.log("model: ", model)
            const e = { ...editItem, ...model };
            setEditedFields({ ...editedFields, ...model });
            setEditItem(e);
            setChanged(true);
        },
        changed: changed,
        save: async () => {
            const success = await api.updateAd(editedFields);
            await loadAll();
        },
        delete: async (id: string) => {
            const success = await api.deleteAd(id);
            await loadAll();
        },
        togglePublish: async (id: string, published: boolean) => {
            const success = await api.togglePublishAd(id, published);
            await loadAll();
        },
        toggleArchived: async (id: string, archived: boolean) => {
            const success = await api.toggleArchiveAd(id, archived);
            await loadAll();
        }

    }
}


const useAdApi = () => {

    return {
        getAds: async (): Promise<AdItemType[]> => {
            const cs: AdItemType[] = await FetchHandler.getJson("/api/ads");
            return cs;
        },
        updateAd: async (e: AdItemType): Promise<boolean> => {
            return await FetchHandler.patchJson("/api/ads/update", e);
        },
        deleteAd: async (id: string): Promise<boolean> => {
            return await FetchHandler.delete("/api/ads/" + id + "/delete");
        },
        togglePublishAd: async (id: string, published: boolean) => {
            return await FetchHandler.patchJson("/api/ads/" + id + "/publish", { published: published });
        },
        toggleArchiveAd: async (id: string, archived: boolean) => {
            return await FetchHandler.patchJson("/api/ads/" + id + "/archive", { archived: archived });
        },
        getAdsProjects: async (): Promise<AdProjectType[]> => {
            const cs: AdProjectType[] = await FetchHandler.getJson("/api/ads/projects");
            return cs;
        },
        getAdsWithState: async (state: AdStateType | "all"): Promise<AdProjectBundleType> => {
            const cs = await FetchHandler.getJson("/api/ads/state/" + state);
            return cs;
            // api/ads/state/{state}
        }
    }
}